export enum WiseTransferStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Done = 'done',
    Blocked = 'blocked',
    Failed = 'failed',
    Canceled = 'canceled',
    Initiated = 'initiated',
}
